import { Link } from "react-router-dom";
import "../styles/Projects.css";
import Footer from "../components/Footer";

// Image

import work1 from "../assets/work-1.webp";
import work2 from "../assets/work-2.jpg";
import work3 from "../assets/work-3.webp";
import work4 from "../assets/work-4.webp";

const Projects = () => {
  return (
    <div className="projects">
      <div className="head">
        <h1>Projects</h1>
        <div>
          <span>art direction</span>
          <span>motion</span>
          <span>video</span>
        </div>
      </div>
      <div className="projects_container">
        <div className="project_box">
          <img src={work1} alt="" />
          <div>
            <h1>
              <span>cyber</span>
            </h1>
            <h1>punk</h1>
            <Link to="/projects/01" onClick={() => {window.top=0}}>
              <div className="project_link">View</div>
            </Link>
          </div>
        </div>
        <div className="project_box">
          <img src={work2} alt="" />
          <div>
            <h1>
              <span>virtual</span>
            </h1>
            <h1>reality</h1>
            <Link to="/projects/01" onClick={() => {window.top=0}}>
              <div className="project_link">View</div>
            </Link>
          </div>
        </div>
        <div className="project_box">
          <img src={work3} alt="" />
          <div>
            <h1>digital</h1>
            <h1>future</h1>
            <Link to="/projects/01" onClick={() => {window.top=0}}>
              <div className="project_link">View</div>
            </Link>
          </div>
        </div>
        <div className="project_box">
          <img src={work4} alt="" />
          <div className="project_hover">
            <h1>neon</h1>
            <h1>lights</h1>
            <Link to="/projects/01" onClick={() => {window.top=0}}>
              <div className="project_link">View</div>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Projects;
